<template>
  <div class="row_center_center coupon" @click="toPage(item.coupons_id)">
    <div class="column_center_between coupon_image">
      <img src="@/assets/coupon_img.png" />
      <input type="button" value="領取" class="claim_button" @click="claim(item.coupons_id)" />
    </div>
    <div class="coupon_detail">
      <div class="column_start_start">
        <text class="coupon_title text_two_lines">{{ item.title }}</text>
        <text class="coupon_descrption text_three_lines">{{ item.description }}</text>
      </div>
      <text class="usage_duration text_one_line">
        使用期限：{{ item.usage_period_begin }} ~ {{ item.usage_period_end }}
      </text>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object
    },
  },
  emits: ['claim', 'toPage'],
  components: {},
  data() {
    return {};
  },
  mounted() { },
  methods: {
    claim(id) {
      event.stopPropagation();
      this.$emit("claim", id);
    },
    toPage(id) {
      this.$emit("toPage", id);
    },
  },
};
</script>
<style lang="scss" scoped></style>
